import {inject, Injectable} from "@angular/core";
import {
    ActionService,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";

export class LoyaltyCardRedemptionRequestData extends EntityData<LoyaltyCardRedemptionRequestData> {
    @field loyaltyCardId: number;
    @field integratedLoyaltyConfigId: number;
    @field providerName: string;
}

/**
 * Service to redeem a points-based loyalty card
 */
@Injectable({providedIn: "root"})
export class LoyaltyCardRedemptionService extends ActionService {
    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- LoyaltyCardRedemptionService");

        super(http, nameSpace, "loyalty-card-redeem", configService, useAsync, actionNames);
    }
}
